import { AxiosResponse } from 'axios';
import $api from './instance';
import { AuthResponse, IUser, SigninDto, SignupDto } from '@/types';

export async function signupRequest(
  data: SignupDto,
): Promise<AxiosResponse<AuthResponse>> {
  return $api.post('/register', data);
}

export async function signinRequest(
  data: SigninDto,
): Promise<AxiosResponse<AuthResponse>> {
  return $api.post<AuthResponse>('/login', data);
}

export async function logoutRequest() {
  return $api.post('/logout');
}

export async function forgotPassword(data: { email: string }) {
  return $api.post('/forgot', data);
}

export async function resetForgotPassword(data: {
  password: string;
  token: string;
}) {
  return $api.post('/forgot-reset', data);
}

export async function getProfileRequest() {
  return $api.get('/profile');
}

export async function updateProfileRequest(
  data: Partial<IUser>,
): Promise<AxiosResponse<IUser>> {
  return $api.patch<IUser>('/profile', data);
}

export async function changePassword(data: {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}) {
  return $api.post('/auth/change-password', data);
}

export async function getUserEmailByInviteToken({
  inviteToken,
}: {
  inviteToken: string;
}): Promise<{ email: string }> {
  const res = await $api.get(`/auth/info-by-invite/${inviteToken}`);
  return res.data;
}

export async function confirmEmailRequest(token: string) {
  return $api.get(`/auth/confirm/${token}`);
}

export async function resendConfirmationEmailRequest(data: { email: string }) {
  return $api.post('/auth/resend-confirmation', data);
}

export async function isPhoneRegistered(
  phone: string,
): Promise<AxiosResponse<{ isRegistered: boolean }>> {
  return $api.get('/users/is-phone-registered', {
    params: { phone },
  });
}

export interface AuthActivityLog {
  id: number;
  eventType: 'auth.login.success' | 'auth.login.failed';
  createdAt: string;
  metadata: {
    ip: string;
    userAgent: string;
    deviceInfo: {
      browser?: { name: string; version: string };
      os?: { name: string; version: string };
      device?: { vendor?: string; model?: string };
    };
    location?: {
      city: string;
      country: string;
    };
  };
}

export interface AuthActivityResponse {
  logs: AuthActivityLog[];
  total: number;
  page: number;
  limit: number;
}

export async function getAuthActivity(
  page: number = 1,
  limit: number = 10,
): Promise<AxiosResponse<AuthActivityResponse>> {
  return $api.get('/auth/activity', {
    params: {
      page,
      limit,
    },
  });
}
